import { gql } from 'graphql-request'

export default gql`
  mutation saveMedicalEquipmentRoutine(
    $tipoSolicitacao: String
    $tipoOrigem: String
    $hOrigem: Int
    $prestador: Int
    $hEndereco: Int
    $enderecoLivre: String
    $hEquipamento: Int
    $equipamentoLivre: String
    $observacao: String
    $ano: Int
    $marca: String
    $modelo: String
    $serie: String
  ) {
    applications {
      medicalEquipment {
        saveRoutine(
          tipoSolicitacao: $tipoSolicitacao
          tipoOrigem: $tipoOrigem
          hOrigem: $hOrigem
          prestador: $prestador
          hEndereco: $hEndereco
          enderecoLivre: $enderecoLivre
          hEquipamento: $hEquipamento
          equipamentoLivre: $equipamentoLivre
          observacao: $observacao
          ano: $ano
          marca: $marca
          modelo: $modelo
          serie: $serie
        ) {
          success
          result
        }
      }
    }
  }
`
